import axios from 'axios';
import { Dispatch } from 'react';
import { AnyIfEmpty } from 'react-redux';
import {
    GET_LOCATION_UNITS_LIST_FAILURE,
    GET_LOCATION_UNITS_LIST_REQUEST,
    GET_LOCATION_UNITS_LIST_SUCCESS,
    GET_LOCATION_UNITS_LIST_APPEND,
    GET_LOCATION_UNITS_LIST_RESET,
} from '../constants/locationUnitsList.constants';

// Request action
const getLocationUnitsListRequest = () => {
    return {
        type: GET_LOCATION_UNITS_LIST_REQUEST,
    };
};

// Success action
const getLocationUnitsListSuccess = (unitsData: { data: AnyIfEmpty<object>[]; count: number }) => {
    return {
        type: GET_LOCATION_UNITS_LIST_SUCCESS,
        payload: unitsData,
    };
};

// Append action for pagination
const getLocationUnitsListAppend = (unitsData: { data: AnyIfEmpty<object>[]; count: number }) => {
    return {
        type: GET_LOCATION_UNITS_LIST_APPEND,
        payload: unitsData,
    };
};

// Failure action
const getLocationUnitsListFailure = (error: string) => {
    return {
        type: GET_LOCATION_UNITS_LIST_FAILURE,
        payload: error,
    };
};

// Reset action
export const resetLocationUnitsList = () => {
    return {
        type: GET_LOCATION_UNITS_LIST_RESET,
    };
};

// Main action creator with pagination support
export const getLocationUnitsList = (
    locationId: string | undefined | null,
    params?: {
        searchText?: string;
        page?: number;
        limit?: number;
    },
    append: boolean = false // If true, append to existing data (for pagination)
) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getLocationUnitsListRequest());
        return axios
            .get(`/admin/units/list/${locationId}`, {
                params: {
                    ...(params?.searchText && { searchText: params.searchText }),
                    ...(params?.page && { page: params.page }),
                    ...(params?.limit && { limit: params.limit }),
                },
            })
            .then((response) => {
                if (append) {
                    dispatch(getLocationUnitsListAppend(response.data));
                } else {
                    dispatch(getLocationUnitsListSuccess(response.data));
                }
                return response.data;
            })
            .catch((error) => {
                dispatch(getLocationUnitsListFailure(error?.response?.data?.message || error.message));
                throw error;
            });
    };
};

